export const environment = {
    production: true,
    baseHref: 'https://qa.cdn.aa.com/homepage/components',
    server: 'https://homepage-webcomponents.qa.aa.com',
    airPassMemberCheckEndpoint: '/home/api/book',
    //bookEndpoint: "/booking/find-flights",
    bookEndpoint: 'https://search-availability-interstitial-page.qa.aa.com/booking/find-flights/search',
    showFormValue: false,
    airport: {
        countriesEndpoint: '/airport/countries',
        statesEndpoint: '/airport/states',
        airportsEndpoint: '/airport/airports',
        nearestAirportEndPoint: '/airport/nearestAirport',
        airportTypeaheadEndpoint: '/home/ajax/airportLookup'
    },
    flightStatus: {
        cityEndPoint : '/travelInformation/flights/status',
        cityResultEndPoint : '/travelInformation/flights/status/result',
        flightNumberEndPoint :'/travelInformation/flights/status/detail?search=AA|'
    },
    tealium: {
        account: 'aa',
        profile: 'main',
        env: 'qa'
    },
    dcf_CDN_Url : 'https://qa.cdn.aa.com/dcfsmartweb/dist/dcf-smartwebservice-qa.js'
};
